import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { UserDto } from 'projects/shared/src/lib/models/User';
import { AccountService } from 'projects/shared/src/lib/services/account.service';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { OAuthServiceService } from 'projects/shared/src/lib/services/o-auth-service.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';

@Component({
  selector: 'edit-user-profile-info',
  templateUrl: './edit-user-profile-info.component.html',
  styleUrls: ['./edit-user-profile-info.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EditUserProfileInfoComponent implements OnInit {
  @Input('user') user!:UserDto;

  userForm!: FormGroup;
  _userrole!: string;
  _isadmin!:string;
  _db!:string;

  constructor(private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private accountService: AccountService,
    private tenantService:TenantService,
    private oauthService: OAuthServiceService,
    public translate: TranslateService,
    private notificationService: NotificationService) { }

  ngOnInit(): void {
    console.log("------------> edituserInfo = ", this.user)
    this.buildUserForm(this.user); 

    this.oauthService.userData.subscribe({
      next: (data) => {
        if (typeof data != undefined && data != null) {
          let userRoles = data.role as Array<string>;
          userRoles.forEach((role: string) => {
            if (role === 'squirrel') {
              this._userrole = role;
            }
          });
        }
      }
    });
  }

  get admin(): string {
    this.oauthService.userData.subscribe({
      next: (data) => {
        if (typeof data != undefined && data != null) {
          let userRoles = data.role as Array<string>;
          userRoles.forEach((dbrole: string) => {
            if (dbrole === 'admin' ) {
              this._isadmin = dbrole;
              this._db = dbrole;
            }
          });
        }
      }
    });
    return this._isadmin;
  }
  
  
  buildUserForm(user: UserDto) {
    let emailregex: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    this.userForm = this.formBuilder.group({
      id: [user.id],
      email: [user.email],
      emailConfirmed: [user.emailConfirmed],
      userName: [user.userName],
      phoneNumber: [user.phoneNumber],
      phoneNumberConfirmed: [user.phoneNumberConfirmed],
      lockoutEnabled: [user.lockoutEnabled],
      twoFactorEnabled: [user.twoFactorEnabled],
      lockoutEnd: [user.lockoutEnd]
    });
  }  

  editUserInfo() {

    if (this.userForm.valid) {

      let userDto = new UserDto;
      userDto.id = this.userForm.value.id;
      userDto.userName = this.userForm.value.userName;
      userDto.email = this.userForm.value.email;
      userDto.emailConfirmed = this.userForm.value.emailConfirmed;
      userDto.phoneNumber = this.userForm.value.phoneNumber;
      userDto.phoneNumberConfirmed = this.userForm.value.phoneNumberConfirmed;
      userDto.lockoutEnabled = this.userForm.value.lockoutEnabled;
      userDto.twoFactorEnabled = this.userForm.value.twoFactorEnabled;
      userDto.lockoutEnd = this.userForm.value.lockoutEnd;

      // if (this._db) {
      //   this.updateInMainDb(userDto)
      // }
      // else {
        this.updateInTenantDb(userDto)
      // }
    }
  }

  updateInTenantDb(userDto: UserDto) {
    let db:string = this.tenantService.currentTenantName;
    this.tenantService.updateUser(db, userDto).subscribe({
      next: () => {
        this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["USERUPDATED"]}`);
      },
      error: () => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["USERUPDATEDERROR"]}`)
    });
  }

  updateInMainDb(userDto: UserDto) {
    this.accountService.updateUser(userDto).subscribe({
      next: () => {
        this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["USERUPDATED"]}`);
      },
      error: () => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["USERUPDATEDERROR"]}`)
    });
  }
}

